import { FC, useMemo } from 'react'
import { ACTION_TYPE } from '../../../models/post'
import LoadableImage from '../../UI/LoadableImage'

import AttentionLogo from '../../../assets/img/example/project.png'

import './PostActionTitle.scss'

import EditIcon from '../../UI/Icons/Edit'
import CustomButton from '../../UI/Buttons/CustomButton'
import CheckCircleIcon from '../../UI/Icons/CheckCircleIcon'

interface PostActionTitleProps {
  from: string | null
  to?: string
  type: ACTION_TYPE
  avatar: string | null
  isEditableMode: boolean
  setIsEditableMode: Function
  setOpenEditInput?: () => any
  shouldEnableEdit?: boolean
  shouldShowEditIcon?: boolean
}

const PostActionTitle: FC<PostActionTitleProps> = ({
  type,
  from,
  to,
  avatar,
  setOpenEditInput,
  isEditableMode,
  setIsEditableMode,
  shouldEnableEdit,
  shouldShowEditIcon
}) => {
  const name = useMemo(() => from || 'Attention Nest', [from])

  const isEditinput = () => {
    setIsEditableMode()
    if (setOpenEditInput) {
      setOpenEditInput()
    }
  }

  const actionTitle = useMemo(() => {
    switch (type) {
      case ACTION_TYPE.TYPE_APPROVAL_STARTED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> created the content
            and sent{' '}
            {to && (
              <>
                to <strong className='post-action_content-body_strong'>{to}</strong>
              </>
            )}{' '}
            for approval
          </>
        )
      case ACTION_TYPE.TYPE_EXTERNAL_APPROVAL_STARTED:
        return <>Content has been sent for external approval</>
      case ACTION_TYPE.TYPE_REVISION_REQUESTED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> pushed notes
          </>
        )
      case ACTION_TYPE.TYPE_QUESTION_PUSHED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> asked a question
          </>
        )
      case ACTION_TYPE.TYPE_ANSWER_PUSHED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> replied on question
          </>
        )
      case ACTION_TYPE.TYPE_APPROVED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> successfully
            approved the content
          </>
        )
      case ACTION_TYPE.TYPE_APPROVED_BY_ADMIN:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> successfully
            approved the content
          </>
        )
      case ACTION_TYPE.TYPE_APPROVED_BY_SYSTEM:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> successfully
            approved the content
          </>
        )
      case ACTION_TYPE.TYPE_APPROVAL_SKIPPED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> skipped the
            approval and content has scheduled successfully
          </>
        )
      case ACTION_TYPE.TYPE_UNAPPROVED:
        return (
          <>
            <strong className='post-action_content-title_strong'>{name}</strong> has unapproved the
            content
          </>
        )
    }
  }, [type, name, to])

  return (
    <div className='post-action_content-title-container'>
      <div key={`post-conversation-avatar-${avatar}`}>
        <LoadableImage media={avatar || AttentionLogo} />
      </div>
      <div className='post-action_content-title'>{actionTitle}</div>

      {ACTION_TYPE.TYPE_REVISION_REQUESTED && shouldEnableEdit && shouldShowEditIcon ? (
        <div className='post-action_content-edit'>
          {isEditableMode ? (
            <CustomButton className='w-35' button='subtle' size='small' onClick={() => isEditinput()}>
              <CheckCircleIcon />
            </CustomButton>
          ) : (
            <CustomButton className='w-35' button='subtle' size='small' onClick={() => isEditinput()}>
              <EditIcon />
            </CustomButton>
          )}
        </div>
      ) : null}
    </div>
  )
}

export default PostActionTitle
